// extracted by mini-css-extract-plugin
export default {"svg":"manAndFish_svg__lS+wH"};